.carrierRow {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-sm);
  margin-bottom: var(--mantine-spacing-md);
}

.logoBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  background: var(--adl-surface-container);
  border: 1px solid var(--adl-border-light);
  border-radius: var(--mantine-radius-xs);
  overflow: hidden;
}

.logoInitials {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.carrierInfo {
  display: flex;
  flex-direction: column;
}

.carrierName {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.arrives {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-secondary);
}

.costControl {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.costLabel {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.costTotal {
  font-size: var(--mantine-font-size-sm);
  font-weight: 600;
  color: var(--adl-text-primary);
}

.disclaimer {
  font-size: var(--mantine-font-size-xs);
  color: var(--adl-text-secondary);
}

.invoice {
  display: flex;
  flex-direction: column;
  gap: var(--mantine-spacing-xs);
  margin-top: var(--mantine-spacing-md);
}

.invoiceTitle {
  font-size: var(--mantine-font-size-xs);
  font-weight: 600;
  color: var(--adl-text-secondary);
}

.invoiceCopy {
  font-size: var(--mantine-font-size-sm);
  color: var(--adl-text-primary);
}
